// form-context.ts file
import { AdditionalQuestionResponseType } from '@hhgtech/hhg-components/types'
import { createFormContext } from '@mantine/form'

import { OvulationCalculatorType } from 'components/templates/ovulationCalculator'

export type OvulationFormField = {
  type: OvulationCalculatorType
  cycle: number
  startDate: Date
  periodLength: number
  isSubmitted?: boolean
  birthday?: Date
  isYourself?: boolean
  additionalQuestions?: AdditionalQuestionResponseType[]
}

// You can give context variables any name
export const [
  OvulationFormProvider,
  useOvulationFormContext,
  useOvulationForm,
] = createFormContext<OvulationFormField>()
